import { Generic } from './Span';
export function isSpan(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isSpan;    //# sourceMappingURL=isSpan.js.map
